import type { Review, ReviewPhoto } from '@noths/polaris-design-system-ooux-interfaces';

import type { ProductReview } from 'src/redux/reviews/types';
import type { CatServiceAPIPartner } from 'src/services/cat-service-api/types/CatServiceAPIPartner';

/** Alt text where the customer wrote no caption, which on live data is nearly every photo. */
const PHOTO_ALT_FALLBACK = 'Customer photo';

const adaptPhotos = (media: ProductReview['media']): ReviewPhoto[] =>
  media
    .filter(({ type }) => type === 'photo')
    .map(({ caption, url }) => ({ alt: caption || PHOTO_ALT_FALLBACK, url }));

/**
 * Adds what the store cannot: the reply's partner, joined from the product slice at read
 * time, and `photos` from the photo media only, since a Feefo video's `url` is a player
 * page rather than an image.
 */
export const adaptReviewToUI = (
  review: ProductReview,
  partner: Pick<CatServiceAPIPartner, 'location' | 'logo' | 'name' | 'shortcode'>,
): Review => {
  const photos = adaptPhotos(review.media);

  return {
    date: review.date,
    id: review.id,
    rating: review.rating,
    ...(photos.length > 0 && { photos }),
    ...(review.reviewer && { reviewer: review.reviewer }),
    ...(review.text && { text: review.text }),
    ...(review.reply && {
      reply: {
        partner: {
          name: partner.name,
          ...(partner.location && { location: partner.location }),
          ...(partner.logo && { logoUrl: partner.logo }),
          ...(partner.shortcode && { shortcode: partner.shortcode }),
        },
        text: review.reply.text,
        ...(review.reply.date && { date: review.reply.date }),
      },
    }),
  };
};
